<hlm-avatar [variant]="variant">
  <img [src]="imageSrc | base64" alt="Avatar" hlmAvatarImage/>

  <img src="assets/media/avatars/blank.png" alt="avatar" hlmAvatarFallback/>
</hlm-avatar>
